export default __webpack_public_path__ + "static/media/ristora-logo.ae2d0132.svg";